import type { FC, ReactNode } from "react";
import { Fragment, useState } from "react";
import { Modal } from "react-bootstrap";
import { useMediaQuery } from "..";
import Table, { TableColumn } from "../../../components/table";
import { Button } from "../../../modules/button";
import { ColumnContent, LeftRightContent } from "./InformationList";
import "./detail.scss";

type TableModalProps = {
  label?: ReactNode;
  data: unknown[];
  columns: TableColumn<any>[];
};

const TableModal: FC<TableModalProps> = (props) => {
  const { data, columns, label = "Chi tiết:" } = props;
  const breakpoint = useMediaQuery("(max-width: 992px)");

  const table = <Table columns={columns} data={data} />;

  if (breakpoint) {
    return <TableModalDialog table={table} label={label} />;
  }

  return <ColumnContent label={label} content={table} />;
};

export default TableModal;

type TableModalDialogProps = Pick<TableModalProps, "label"> & {
  table: ReactNode;
};

const TableModalDialog: FC<TableModalDialogProps> = (props) => {
  const { table, label } = props;

  const [isOpenModal, setIsOpenModal] = useState(false);

  const openModal = () => {
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  return (
    <Fragment>
      <LeftRightContent
        left={label}
        right={
          <Button className="w-100" buttonType="grey" label="Xem chi tiết" onClick={openModal} />
        }
      />
      <Modal show={isOpenModal} onHide={closeModal} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Chi tiết</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4 px-4">{table}</Modal.Body>
        <Modal.Footer>
          <Button onClick={closeModal} buttonType="grey" label="Đóng" />
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};
